export const API_ROOT = 'https://api.zizbeyjobs.com/'
// export const API_ROOT = 'http://10.0.0.36:8559/'
